import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { JaNeiVetIkke } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

export const HarOppvarmetKjellerRadio = () => {
  const { register, formState } = useOmBoligenFormContext();
  const { t } = useTranslation();

  const error = formState.errors.bygginfo?.isHeatedBasement?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('register.bygningsdetaljer.erKjellerOppvarmet.label')}</Fieldset.Legend>
      <Radio
        {...register('bygginfo.isHeatedBasement', {
          required: t('register.bygningsdetaljer.erKjellerOppvarmet.error'),
          shouldUnregister: true
        })}
        label={t('register.ja')}
        value={JaNeiVetIkke.Ja}
        aria-invalid={!!error}
      />

      <Radio
        {...register('bygginfo.isHeatedBasement', {
          required: t('register.bygningsdetaljer.erKjellerOppvarmet.error'),
          shouldUnregister: true
        })}
        label={t('register.nei')}
        value={JaNeiVetIkke.Nei}
        aria-invalid={!!error}
      />
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
